module.exports = __webpack_public_path__ + "static/img/oa_service.453b401.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/oa_service.png
// module id = INgm
// module chunks = 1